import { useState, useEffect } from "react";
import { Box, Typography, Grid, Paper, Tooltip } from "@mui/material";
import { motion } from "framer-motion";
import { Calendar } from "primereact/calendar";
import { useDispatch, useSelector } from "react-redux";
import {
  DashboardPOSTStatus,
  DashboardStatus,
} from "../../redux/slices/dashboard";
import OverallActiveCustomers from "../../pages/customers";
const AnimatedPaper = motion(Paper);

export function DepositDashboard({ data, title }) {
  const [globalDateRange, setGlobalDateRange] = useState({
    startDate: null,
    endDate: null,
  });
  const loading = useSelector((value) => value.status.loading);

  const dispatch = useDispatch();

  useEffect(() => {
    if (globalDateRange.startDate && globalDateRange.endDate) {
      dispatch(DashboardStatus(globalDateRange));
    }
  }, [globalDateRange]);

  const HandleEndDate = (e) => {
    setGlobalDateRange((prev) => ({ ...prev, endDate: e.value }));
  };

  return (
    <Box py={3}>
      <Typography variant="h5" gutterBottom>
        {title}
      </Typography>

      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        mb={4}
        flexWrap="wrap"
        gap={2}
      >
        <Typography variant="h6">Overview</Typography>
        <Box
          display="flex"
          gap={1}
          alignItems="center"
          flexWrap="wrap"
          border={1}
          borderColor="grey.500"
          boxShadow={2}
          borderRadius={2}
          p={2}
          bgcolor={"white"}
        >
          <Calendar
            value={globalDateRange.startDate}
            onChange={(e) =>
              setGlobalDateRange((prev) => ({ ...prev, startDate: e.value }))
            }
            placeholder="From Date"
            showIcon
            dateFormat="dd/mm/yy"
          />

          <Calendar
            value={globalDateRange.endDate}
            onChange={HandleEndDate}
            placeholder="To Date"
            showIcon
            dateFormat="dd/mm/yy"
          />
        </Box>
      </Box>

      <Grid container spacing={3}>
        {data?.map((item, index) => (
          <Grid item xs={12} sm={6} md={4} key={index} width={300}>
            {item.label === "Active Agents" ? (
              <AnimatedPaper
                elevation={4}
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: 2,
                  px: 5,
                  py: 6,
                  borderRadius: "16px",
                  height: "100%",
                  justifyContent: "center",
                  transition: "transform 0.2s, box-shadow 0.2s",
                  "&:hover": {
                    transform: "scale(1.05)",
                    boxShadow: "0 6px 24px rgba(0,0,0,0.2)",
                  },
                }}
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.5 }}
              >
                <Box display="flex" alignItems="center" gap={2}>
                  {item.icon}
                  <Box>
                    <Typography
                      variant="body2"
                      color="text.secondary"
                      sx={{
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }}
                    >
                      {item.label}
                    </Typography>
                    <Tooltip
                      title="Active agents will appear here"
                      arrow
                      placement="top"
                    >
                      <Typography
                        variant="h6"
                        fontWeight="bold"
                        component="span"
                      >
                        {loading ? (
                          <div className="flex items-center justify-center space-x-2">
                            <span>Loading...</span>
                            <svg
                              className="animate-spin h-7 w-7 text-white"
                              xmlns="http://www.w3.org/2000/svg"
                              fill="none"
                              viewBox="0 0 24 24"
                            >
                              <circle
                                className="opacity-25"
                                cx="12"
                                cy="12"
                                r="10"
                                stroke="currentColor"
                                strokeWidth="4"
                              ></circle>
                              <path
                                className="opacity-75"
                                fill="currentColor"
                                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                              ></path>
                            </svg>
                          </div>
                        ) : (
                          item.value
                        )}
                      </Typography>
                    </Tooltip>
                  </Box>
                </Box>
              </AnimatedPaper>
            ) : (
              <AnimatedPaper
                elevation={4}
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: 2,
                  px: 5,
                  py: 6,
                  borderRadius: "16px",
                  height: "100%",
                  // width: "100%",
                  justifyContent: "center",
                  transition: "transform 0.2s, box-shadow 0.2s",
                  "&:hover": {
                    transform: "scale(1.05)",
                    boxShadow: "0 6px 24px rgba(0,0,0,0.2)",
                  },
                }}
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.5 }}
              >
                <Box display="flex" alignItems="center" gap={2}>
                  {item.icon}
                  <Box>
                    <Typography
                      variant="body2"
                      color="text.secondary"
                      sx={{
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }}
                    >
                      {item.label}
                    </Typography>
                    <Typography variant="h6" fontWeight="bold">
                      {loading ? (
                        <div className="flex items-center justify-center space-x-2">
                          <span>Loading...</span>

                          <svg
                            className="animate-spin h-7 w-7 text-white"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                          >
                            <circle
                              className="opacity-25"
                              cx="12"
                              cy="12"
                              r="10"
                              stroke="currentColor"
                              strokeWidth="4"
                            ></circle>
                            <path
                              className="opacity-75"
                              fill="currentColor"
                              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                            ></path>
                          </svg>
                        </div>
                      ) : (
                        item.value
                      )}
                    </Typography>
                  </Box>
                </Box>
              </AnimatedPaper>
            )}
          </Grid>
        ))}
      </Grid>
      <OverallActiveCustomers />
    </Box>
  );
}

export default DepositDashboard;
